import { render } from "./MessageAlert.vue?vue&type=template&id=65049419"
import script from "./MessageAlert.vue?vue&type=script&lang=js"
export * from "./MessageAlert.vue?vue&type=script&lang=js"

import "./MessageAlert.vue?vue&type=style&index=0&id=65049419&lang=css"

import exportComponent from "/var/jenkins_home/workspace/tl-demo-web_v2.0.9.4/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__